import React from 'react';
import { Route, IndexRedirect } from 'react-router';
import TabBar from '../TabBar';

import DataMovementBetweenTablesList from './DataMovement/BetweenTables/TableList';
import DataMovementBetweenTablesAdd from './DataMovement/BetweenTables/TableAdd';
import DataMovementBetweenTablesDetail from './DataMovement/BetweenTables/TableDetail';
import DeleteObservation from "./DeleteObservation/DeleteObservation";
import ManualInterpolationList from './Interpolation/ManualInterpolationList';
import Interpolation from './Interpolation/Interpolation';

const ToolsHome = props => {
  return (
    <div className='inner-section-root'>
      <TabBar
        items={[
          { to: '/tools/data_movement', label: 'Data Movement' },
          { to: '/tools/delete_observation', label: 'Delete Observation' },
          // { to: `/tools/interpolation`, label: 'Interpolation' },
          { to: `/tools/manual-interpol`, label: 'Manual Interpolation' },
        ]}
      />
      <div className='inner-section-content'>
        {props.children}
      </div>
    </div>
  );
};

export const ToolsRoutes = () => (
  <Route component={ToolsHome}>
    <IndexRedirect to="data_movement" />
    <Route path="data_movement" component={DataMovementBetweenTablesList} >
      <Route path="add" component={DataMovementBetweenTablesAdd} />
      <Route path=":id/details" component={DataMovementBetweenTablesDetail} />
    </Route>
    <Route path='delete_observation' component={DeleteObservation} />
    <Route path='manual-interpol' component={ManualInterpolationList} />
    <Route path='interpolation' component={Interpolation} />
  </Route>

);


// WEBPACK FOOTER //
// ./src/components/Tools/routes.js